export default "__VITE_ASSET__CxhU3YUr__"